module.exports = __webpack_public_path__ + "img/banner2.f519fa24.png";